export type RuntimeConfig = {
  [key: string]: string | undefined;
};

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RuntimeConfig;
  }
}

function isBrowser(): boolean {
  return typeof window !== "undefined";
}

export function getRuntimeConfig(): RuntimeConfig {
  if (isBrowser() && window.__RUNTIME_CONFIG__) {
    return window.__RUNTIME_CONFIG__ as RuntimeConfig;
  }
  return {};
}

export function getRuntimeValue(key: string): string | undefined {
  const cfg = getRuntimeConfig();
  return cfg[key];
}
